module.exports = __webpack_public_path__ + "static/media/TileFIDO.e4081f6c.png";